
// query-string v9 espone solo l'export default (in v6 era `import { stringify }`)
import queryString from 'query-string';

import moment from 'moment';

const { stringify } = queryString;

const cache = {};

const parseCacheControl = (cacheControlHeader) => {
  if (!cacheControlHeader) return null;
  const match = cacheControlHeader.match(/max-age=(\d*)/);
  if (!match) return null;
  return Number(match[1]);
};

cache.getCachedResponse = (path, params, authToken) => {
  const key = authToken && `${path}?${stringify(params)}__${authToken}`;
  if (!key) return null;
  const cachedResponse = sessionStorage.getItem(key);
  const parsedCachedResponse = cachedResponse && JSON.parse(cachedResponse);
  if (parsedCachedResponse && parsedCachedResponse.expireAt &&
     moment(parsedCachedResponse.expireAt).isSameOrBefore(moment())) {
    sessionStorage.removeItem(key);
    return null;
  }
  return parsedCachedResponse;
};

cache.cacheResponse = (path, params, authToken, response) => {
  const key = authToken && `${path}?${stringify(params)}__${authToken}`;
  if (!key) return;
  if (!response.data || (Array.isArray(response.data) && !response.data.length) || (typeof response.data === 'object' && !Object.keys(response.data).length)) {
    sessionStorage.removeItem(key);
    return;
  }
  const cacheControl = parseCacheControl(response.headers['cache-control']);
  if (typeof cacheControl === 'number') {
    sessionStorage.setItem(key, JSON.stringify({ data: response.data, expireAt: moment().add(cacheControl, 'seconds').toDate() }));
  }
};

export default cache;
